import React from "react";
import { node, string } from "prop-types";
import { BRAND_CODE_OM } from "../../../../constants";
import SectionHeroDefault from "./brand/Default";
import SectionHeroOmiq from "./brand/Omiq";
import heroConfig from "./heroConfig";

const SectionHero = ({ brandCode, children, ...props }) => {
	const HeroComponent = brand => {
		switch (brand.toLowerCase()) {
			case BRAND_CODE_OM:
				return SectionHeroOmiq;
			default:
				return SectionHeroDefault;
		}
	};

	const HeroBrand = HeroComponent(brandCode);

	return (
		<HeroBrand config={heroConfig} brandCode={brandCode} {...props}>
			{children}
		</HeroBrand>
	);
};

SectionHero.propTypes = {
	brandCode: string,
	children: node.isRequired,
};

export default SectionHero;
